/**
 * Header component.
 * @module components/theme/Header/Header
 */

import React, { Component } from 'react';
import { Segment } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Image } from 'semantic-ui-react';
import { getUser } from '@plone/volto/actions';
// import LogoImage from '@plone/volto/components/theme/Logo/Logo.svg';
import LogoImage from 'volto-deba/../theme/site/assets/images/i_armarria.png';
import {
  LanguageSelector,
  Logo,
  Navigation,
  SearchWidget,
} from '@plone/volto/components';
import jwtDecode from 'jwt-decode';
import messages from 'volto-deba/components/Utils/overrideMessages.js';
import { useIntl } from 'react-intl';

/**
 * Header component class.
 * @class Header
 * @extends Component
 */

function SubsiteContent() {
  const intl = useIntl();

  return (
    <>
      <div className="main-navigation">
        <div className="main-site-logo">
          <Link to="/" title={intl.formatMessage(messages.debaTown)}>
            <Image
              src={LogoImage}
              size="mini"
              alt="Debako armarria"
              title={intl.formatMessage(messages.debaTown)}
              width="25"
              height="25"
            />
            <span className="main-site-logo-text">deba.eus</span>
          </Link>
        </div>
        <div className="main-navigation-contact d-none d-lg-block">
          <span className="top-phone">943 19 24 52</span> |{' '}
          <a href="mailto:turismoa@deba.eus" className="top-email">
            turismoa@deba.eus
          </a>{' '}
          |{' '}
          <Link
            to={intl.formatMessage(messages.officeUrl)}
            className="top-bulegoa"
          >
            {intl.formatMessage(messages.touristOffice)}
          </Link>{' '}
          |
          <SearchWidget />
          |
          <LanguageSelector />
        </div>
        <div className="main-navigation-contact d-lg-none">
          <span className="top-phone">943 19 24 52</span> |{' '}
          <Link
            to={intl.formatMessage(messages.officeUrl)}
            className="top-bulegoa"
          >
            {intl.formatMessage(messages.office)}
          </Link>
        </div>
      </div>
    </>
  );
}
class Header extends Component {
  /**
   * Property types.
   * @property {Object} propTypes Property types.
   * @static
   */
  static propTypes = {
    token: PropTypes.string,
    pathname: PropTypes.string.isRequired,
    user: PropTypes.shape({
      fullname: PropTypes.string,
      email: PropTypes.string,
      home_page: PropTypes.string,
      location: PropTypes.string,
      roles: PropTypes.array,
    }).isRequired,
    getUser: PropTypes.func.isRequired,
  };

  componentDidMount() {
    getUser(this.props.token);
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.token !== this.props.token) {
      this.props.getUser(nextProps.token);
    }
  }
  /**
   * Default properties.
   * @property {Object} defaultProps Default properties.
   * @static
   */
  static defaultProps = {
    token: null,
  };

  constructor(props) {
    super(props);

    this.state = {
      mobileMenuOpen: false,
      mobileSearchBoxOpen: false,
    };
  }

  /**
   * Render method.
   * @method render
   * @returns {string} Markup for the component.
   */
  render() {
    return (
      <>
        <Segment basic className="header-wrapper" role="banner">
          <div className="header">
            {!this.props.subsite ? (
              <>
                <div className="logo-nav-wrapper">
                  <div className="logo">
                    <Logo />
                  </div>
                  <Navigation pathname={this.props.pathname} />
                  <div className="tools-search-wrapper">
                    <div className="search">
                      <SearchWidget />
                    </div>
                    <LanguageSelector />
                  </div>
                </div>
              </>
            ) : (
              <>
                <SubsiteContent />
                <div className="logo-nav-wrapper container ui">
                  <div className="logo">
                    <Logo />
                  </div>
                  <Navigation pathname={this.props.pathname} />
                </div>
              </>
            )}
          </div>
        </Segment>
      </>
    );
  }
}
export default connect(
  (state) => ({
    roles: state.users.user.roles,
    user: state.users.user,
    token: state.userSession.token
      ? jwtDecode(state.userSession.token).sub
      : '',
    rawtoken: state.userSession.token,
    subsite: state.subsite?.data,
  }),
  { getUser },
)(Header);
